import React from 'react'
// components
import { Button } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// views
import { FilterIcon, FilterSelectedIcon } from './views'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// themes
import { colors } from 'themes/index'
// constants
import { Modals } from 'constants/modals'
// context
import { LogicalConditionsContext } from 'containers/Risks/RiskTemplate/Edit/layers/LogicalConditions'
// types
import { IField, RiskTemplateFormConditionActionType } from 'types/graphql'

interface Props {
  field: IField
}

const FilterButton: React.FC<Props> = ({ field }) => {
  const { showModal } = useShowModal({ modalType: Modals.LOOKUP_FILTER_MODAL })

  const { currentCondition } = React.useContext(LogicalConditionsContext)

  const fieldCondition = currentCondition?.actions?.find(
    (a) => a.fieldId === field.id && a.type === RiskTemplateFormConditionActionType.LimitResponse
  )

  const hasOptions = fieldCondition
    ? fieldCondition.value?.businessUnitsIds
    : !!field.limitResponse?.value?.businessUnitsIds?.length

  const onFilterClick = () => showModal({ field })

  const isCurrentField = currentCondition?.fieldId === field.id

  return (
    <Button onClick={onFilterClick} disabled={isCurrentField}>
      {hasOptions ? (
        <FilterSelectedIcon color={fieldCondition ? colors.purple300 : colors.blue500} />
      ) : (
        <FilterIcon color={fieldCondition ? colors.purple300 : colors.blue500} />
      )}
    </Button>
  )
}

export default FilterButton
